import { Component } from '@angular/core';
import { DataServiceService } from '../helpers/data.service';
import { ConfigService } from '../helpers/config.service';

@Component({
    selector: 'app-rtb',
    templateUrl: './rtb.component.html',
    styleUrl: './rtb.component.scss',
    standalone: false
})
export class RtbComponent {
  csData:any = {};
  showCsData:boolean = true;
  constructor(public data:DataServiceService, public cs: ConfigService){
    this.data.setIsCouponLastStep(false);
    this.data.setHeaderMenuSelection('4');
  }

  async ngOnInit(): Promise<void> {
    this.csData = {};
    this.showCsData = true;
    await this.cs.getConfigurations('rtbhouse', 'en');
    this.data.setCsObj(this.cs);
    this.csData = this.cs;
    setTimeout(() => {
      this.showCsData = false;
  }, 100);
  }
}
